<template>
    <v-container style="max-width:100vw;">
        <v-navigation-drawer style="top: 0px; max-height:100vh!important;" right v-model="show_filters" :clipped="$vuetify.breakpoint.lgAndUp" app>
            <filterMovements/>
        </v-navigation-drawer>
        <v-dialog v-model="filterMobile" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
            <filterMovements @closeFilter="closeFilter"/>
            </v-card>
        </v-dialog>
        <!-- Contenedor show-select -->
        <v-data-table 
            :options.sync="options" 
            :footer-props="{'items-per-page-options':[15, 30, 50, meta.total]}"
            :server-items-length="meta.total"
            :headers="headers" 
            :items="tableItems"
            :loading="loader"
            class="elevation-0 px-6 py-4">
            <template v-slot:[`item.type`]="{ item }">
                <v-list-item class="px-0" style="min-height:0px!important; font-size:14px;" :to="item.type.link!=''?{ path: item.type.link}:undefined">{{item.type.type}}</v-list-item>
            </template>
            <!-- Header -->
            <template v-slot:top>
                <v-toolbar flat style="z-index:9!important;">
                    <div>
                        <v-row class="ma-0 mb-1">
                            <v-toolbar-title>Movimientos de Inventario</v-toolbar-title>
                            <v-btn  class="ml-2" small icon @click="openFilter()">
                                <v-badge overlap color="primary" :content="filtersLength" :value="filtersLength">
                                    <v-icon>mdi-filter</v-icon>
                                </v-badge>
                            </v-btn>
                        </v-row>
                        <v-btn @click="recalcularInventarios()" x-small outlined>Recalcular Inventarios</v-btn>
                    </div>
                    <v-spacer></v-spacer>
                    <v-chip v-if="selected_product_inventory !== undefined && selected_product_inventory !== null">Inventario Actual: {{selected_product_inventory}}</v-chip>
                    <v-spacer></v-spacer>
                    <itemsAutocomplete @selectedItem="selectedItem" style="width:500px;"/>
                </v-toolbar>
            </template>
        </v-data-table>
        <v-snackbar :color="snackbar.color" v-model="snackbar.show">
            {{ snackbar.message }}
        </v-snackbar>
    </v-container>
</template>

<script>
import axios from "axios"
import filterMovements from "../movements/filter.vue"
import itemsAutocomplete from "../helpers/items_autocomplete.vue"
export default {
    components: {
        'filterMovements':filterMovements,
        'itemsAutocomplete':itemsAutocomplete
    },
    data:()=>({
        filterMobile:false,
        show_filters:false,
        options: {
            page: 1,
            itemsPerPage: 15,
            sortBy: ['inventories.created_at'],
            sortDesc: [true],
        },
        selected_product_id:null,
        selected_product_inventory:undefined,
        snackbar: {
            show: false,
            message: null,
            color: null
        },
    }),
    watch: {
        options: {
            handler() {
                this.fetchData()
            },
            deep: true,
        },
    },
    computed: {
        currentUser(){
            return this.$store.state.currentUser.user
        },
        headers(){
            return [
            { text: 'Tipo', value: 'type' },
            { text: 'Código 1', value: 'code_one' },
            { text: 'Código 2', value: 'code_two' },
            { text: 'Producto', value: 'items.name' },
            { text: 'Movimiento', value: 'quantity' },
            { text: 'Fecha', value: 'inventories.created_at' },
            { text: 'Usuario', value: 'created_by_user_id' },
            { text: 'Existencia', value: 'inventory' },
            //{ text: 'Costo', value: 'cost' },
        ]},
        tableItems(){
            return this.$store.state.inventory_movements.data.map(item=>{return{
                ...item,
                type:this.type(item.type, item.production_id, item.sale_id, item.shopping_id),
                //cost:(item.unit_cost*1)?.toLocaleString('es-MX', { style: 'currency', currency: 'MXN',}),
                'items.name':item.item_name,
                'inventories.created_at':item.created_at_formatted,
                created_by_user_id:item.created_by_name
            }})
        },
        meta(){
            return this.$store.state.inventory_movements.meta
        },
        filtersLength(){
            return this.$store.state.inventory_movements.filters_length
        },
        loader(){
            return this.$store.state.inventory_movements.loader
        },
    },
    methods:{
        recalcularInventarios(){
            axios.get(process.env.VUE_APP_BACKEND_ROUTE + 'api/v2/recalculateInventories').then(response => {
                this.refreshSelectedProductInventory
                const resp = response.data
                this.snackbar = {
                    message: resp.message + ', ' + resp.items_updated + ' productos actualizados, ' + resp.total_processed + ' productos procesados.',
                    color: 'success',
                    show: true
                }
            })
        },
        selectedItem: function(product) {
            if(product == null){
                this.selected_product_id = null
                this.selected_product_inventory = undefined
                this.fetchData()
                return
            }
            this.selected_product_id = product.id
            this.$store.dispatch('inventory_movements/updateFilters', {item_id: product.id})
            this.refreshSelectedProductInventory(product.id)
        },
        fetchData(){
            this.$store.dispatch('inventory_movements/getData', this.options).finally(() => {
                this.refreshSelectedProductInventory()
            })
        },
        refreshSelectedProductInventory(productId = this.selected_product_id){
            if(productId == null || productId === ''){
                this.selected_product_inventory = undefined
                return
            }
            this.selected_product_id = productId
            axios
                .get(process.env.VUE_APP_BACKEND_ROUTE + 'api/v2/item/pos?filter[id]=' + productId + '&itemsPerPage=1')
                .then(response => {
                    const item = response.data?.data?.[0]
                    this.selected_product_inventory = item?.current_inventory
                })
        },
        handleWindowFocus(){
            this.fetchData()
        },
        handleVisibilityChange(){
            if(document.visibilityState === 'visible'){
                this.fetchData()
            }
        },
        permissions(permission) {
            if (this.currentUser.id === 1) {
                return true
            }
            return this.currentUser?.permissions?.includes(permission) || false
        },
        openFilter(){
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                this.filterMobile = true
            }else{
                this.show_filters?(this.$emit("closeDrawer", true), this.show_filters = false):(this.$emit("closeDrawer", false), this.show_filters = true)
            }
        },
        closeFilter(){
            this.filterMobile = false
        },
        type(type, production_id, sale_id, shopping_id){
            if(production_id!=null){
                return {
                    'type': type + ' ' + production_id,
                    'link': '/productions/'+ production_id
                }
            }else if(sale_id!=null){
                return {
                    'type': type + ' ' + sale_id,
                    'link': '/sales/'+ sale_id
                }
            }else if(shopping_id!=null&&shopping_id!=undefined&&shopping_id!=''){
                return {
                    'type': type + ' ' + shopping_id,
                    'link': '/shoppings/'+ shopping_id
                }
            }else{
                return {
                    'type': type,
                    'link': ''
                }
            }
        },
    },
    mounted() {
        this.fetchData()
        window.addEventListener('focus', this.handleWindowFocus)
        document.addEventListener('visibilitychange', this.handleVisibilityChange)
    },
    beforeDestroy() {
        window.removeEventListener('focus', this.handleWindowFocus)
        document.removeEventListener('visibilitychange', this.handleVisibilityChange)
    },
}
</script>
<style scoped>
.item-hover:hover{
    background: #00000008;
}
</style>
<style>
.v-data-table__progress th{
    display: table-cell;
    padding-bottom:5px!important;
}
</style>
